var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#0A0D1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9988 46C35.9658 46 34.9416 45.8174 33.9401 45.4535C29.5279 43.8507 25.4324 41.2402 22.0963 37.9041C18.7602 34.5681 16.1497 30.4726 14.5469 26.0604C14.0319 24.6424 13.8799 23.1787 14.0953 21.7098C14.2971 20.3339 14.8301 18.9981 15.6367 17.8469C16.4469 16.6906 17.5269 15.7289 18.7601 15.0658C20.0752 14.3586 21.5106 14 23.0265 14C23.498 14 23.9055 14.3294 24.0043 14.7904L25.5739 22.115C25.6449 22.4467 25.543 22.7918 25.3032 23.0317L22.6212 25.7136C25.1513 30.7438 29.2566 34.8491 34.2868 37.3791L36.9686 34.6972C37.2085 34.4573 37.5537 34.3555 37.8853 34.4265L45.2099 35.996C45.671 36.0948 46.0003 36.5023 46.0003 36.9738C46.0003 38.4897 45.6417 39.9252 44.9345 41.2403C44.2713 42.4735 43.3096 43.5535 42.1534 44.3637C41.0022 45.1703 39.6665 45.7033 38.2905 45.9051C37.8593 45.9684 37.4282 45.9999 36.9988 46ZM22.2276 16.0437C20.228 16.2644 18.4532 17.3125 17.2746 18.9946C15.9493 20.8861 15.6402 23.2126 16.4267 25.3776C19.508 33.8601 26.1403 40.4924 34.6229 43.5738C36.7878 44.3603 39.1143 44.0513 41.0059 42.7259C42.688 41.5473 43.7361 39.7725 43.9568 37.7729L37.9982 36.4961L35.1973 39.297C34.8993 39.595 34.4464 39.6742 34.0651 39.495C28.1159 36.7001 23.3004 31.8845 20.5055 25.9354C20.3263 25.554 20.4054 25.1011 20.7035 24.8031L23.5044 22.0022L22.2276 16.0437Z",
    fill: "#F2F6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d9d84660.svg";
export { ForwardRef as ReactComponent };